<p *ngIf="loading && !Pdf" role="status">Loading inventory options...</p>
<div *ngIf="loadError" role="alert">{{loadError}} <button class="btn-bg-blue" type="button" mat-button (click)="ngOnInit()">Retry</button></div>
<form *ngIf="!Pdf && !loading && !loadError" #inventoryForm="ngForm" class="form-container">
  <div class="inventory-identity" style="width:97%; display:flex; justify-content:space-between">
    <div style="width:40%">
      <rms-search-select name="Product"
                          [required]="true"
                          [options]="InventoryData.Products"
                          label="Coffee Type"
                          labelKey="LabelName"
                          valueKey="InventoryTypeID"
                          [(ngModel)]="Inventory.InventoryTypeID"
                          (ngModelChange)="setDefaults(true)">
      </rms-search-select>
    </div>
    @if(Inventory.InventoryID){
    <h2 style="width:10%">Ref #: {{Inventory.InventoryID}}</h2>
    }
    <div class="form-field">
      <rms-input name="SupplierReffNumber" [(ngModel)]="Inventory.SupplierReffNumber" label="Supplier Ref #"></rms-input>
    </div>
    <!--<div style="justify-self:right">
      <rms-input name="PriceBasis" type="currency" [(ngModel)]="currentPriceBase" [disabled]="true" label="Current Price Base"></rms-input>
    </div>-->
    <div class="form-field">
      <rms-input type="currency" name="FixationCurrentLevel" [required]="true" [(ngModel)]="Inventory.FixationCurrentLevel" (ngModelChange)="confirmFixationDebounced(); recalculateCostsDebounced()" label="Price Base At Purchase"></rms-input>
    </div>
    @if(Inventory.InventoryTypeID){
    <div class="form-field">
      <rms-input name="Position" [(ngModel)]="Inventory.FinalPosition" label="Position" [disabled]="true"></rms-input>
    </div>
    }
    <div style="align-self:center">
      <app-inventory-website-visibility [(invisible)]="Inventory.WebInvisible" [disabled]="saving"></app-inventory-website-visibility>
    </div>
  </div>

  <div class="cost-summary" *ngIf="Inventory.InventoryTypeID" aria-live="polite">
    <div class="cost-metric"><span>Price / lb</span><strong>{{PerPoundCost}}</strong></div>
    <div class="cost-metric"><span>Commissions / lb</span><strong>{{TotalCommissions | currency:'USD':'symbol':'1.4-4'}}</strong></div>
      <div class="cost-editor" style="display:flex; flex-direction:row; gap:6px; align-items:center">
        <!-- ShippingTerm === 4 => always show Ex-Whse (editable, default 0.00), calc ignores it -->
        @if(Inventory.ShippingTerm === 4){
        <rms-input name="exwhseTerm4" style="width:80%" type="currency"
                    [(ngModel)]="Inventory.ExWhseCost"
                    decimalFormat="1.4-4" label="Ex-Whse Cost"
                    (ngModelChange)="recalculateCostsDebounced()">
        </rms-input>
        }
        @else if(Inventory.ShipmentTypeID === 1){
        <rms-input name="fobex" style="width:80%" type="currency"
                    [(ngModel)]="FOBtoExWarehouseValueTemp"
                    decimalFormat="1.4-4" label="FOBEXWhse-Temp"
                    (ngModelChange)="recalculateCostsDebounced()">
        </rms-input>
        }
        @else{
        <rms-input name="exwhse" style="width:80%" type="currency"
                    [(ngModel)]="Inventory.ExWhseCost"
                    decimalFormat="1.4-4" label="Ex-Whse Cost"
                    (ngModelChange)="recalculateCostsDebounced()">
        </rms-input>
        }

        <button class="btn-bg-blue" type="button" mat-icon-button title="Click To View FOBEXWHSE Calc" (click)="toggleTotals()">
          <mat-icon>info</mat-icon>
        </button>
      </div>


    @if(Inventory.BuyingTermID === 2){
      <div class="cost-metric"><span>Final differential / lb{{Inventory.Child ? ' (decaf)' : ''}}</span><strong>{{(Inventory.Child || Inventory).FinalWarehouseInDifferential | currency:'USD':'symbol':'1.4-4'}}</strong></div>
      <div class="cost-metric"><span>Estimated cost / lb{{Inventory.Child ? ' (decaf)' : ''}}</span><strong>{{(Inventory.Child || Inventory).EstimatedCost | currency:'USD':'symbol':'1.4-4'}}</strong></div>
    } @else {
      <div class="cost-metric"><span>Landed cost / lb{{Inventory.Child ? ' (decaf)' : ''}}</span><strong>{{(Inventory.Child || Inventory).FinalWarehouseInCost | currency:'USD':'symbol':'1.4-4'}}</strong></div>
    }
  </div>
  <p *ngIf="calculationError" role="alert">{{calculationError}}</p>
  <div *ngIf="Inventory.InventoryTypeID && Inventory.FixationCurrentLevel != null" class="flex-columns">
    <div class="form-field">
      <rms-number name="Bags" [(ngModel)]="Inventory.BagsOrdered" label="Bags" [required]="true"
                  (ngModelChange)="onBagsOrMarksChanged(); updateDecafBags()"></rms-number>
    </div>

    <div class="form-field">
      <rms-input name="Marks" [(ngModel)]="Inventory.Marks" label="Marks" [noMargin]="true"
                  (ngModelChange)="onBagsOrMarksChanged()"></rms-input>
    </div>

    <div class="form-field">
      <rms-select name="ETDMonth" [required]="true"
                  [(ngModel)]="Inventory.ETDMonth"
                  (ngModelChange)="onMonthChange($event)"
                  [options]="InventoryData.Months" labelKey="label" valueKey="value" label="ETD Month">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="ETDYear" [disabled]="!Inventory.ETDMonth" [required]="true"
                  [(ngModel)]="Inventory.ETDYear"
                  (ngModelChange)="onYearChange()"
                  [options]="InventoryData.Years" labelKey="label" valueKey="value" label="ETD Year">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="ShippingTerm" [required]="true"
                  [(ngModel)]="Inventory.ShippingTerm"
                  [options]="InventoryData.ShipmentTerms"
                  (ngModelChange)="onShippingTermChange($event); setClosestFuturesMonth()"
                  labelKey="ShipmentTermName" valueKey="ShipmentTermId" label="Shipment Terms">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="Destination" [required]="true"
                  [(ngModel)]="Inventory.Destination"
                  [options]="InventoryData.DestinationPorts"
                  (ngModelChange)="onDestinationChanged()"
                  labelKey="destination_city" valueKey="destination_id" label="Destination Port">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="FinalDestinationWarehouseID" [disabled]="!Inventory.Destination" [required]="true"
                  [(ngModel)]="Inventory.FinalDestinationWarehouseID"
                  (ngModelChange)="onWarehouseChanged(Inventory.FinalDestinationWarehouseID)"
                  [options]="InventoryData.DestinationWarehousesFiltered"
                  labelKey="LocationName" valueKey="LocationID" label="Destination Warehouse">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="PaymentTermsID" [required]="true" [(ngModel)]="Inventory.PaymentTermsID"
                  [options]="InventoryData.PaymentTerms" labelKey="PaymentTermName" valueKey="PaymentTermId" label="Payment Terms">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="ShipmentType" [required]="true"
                  [(ngModel)]="Inventory.ShipmentTypeID"
                  [options]="InventoryData.ShipmentTypes"
                  labelKey="ShipmentTypeName" valueKey="ShipmentTypeId"
                  label="Shipment Type"
                  (ngModelChange)="onShipmentTypeChange($event)">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-input name="NetWeight" [required]="true" type="decimal"
                  [(ngModel)]="Inventory.NetWeight" label="Bag Weight"
                  (ngModelChange)="recalculateCostsDebounced()"></rms-input>
    </div>

    <div class="form-field">
      <rms-select name="WeightTypeID" [required]="true" [(ngModel)]="Inventory.WeightTypeID"
                  [options]="InventoryData.WeightTypes" labelKey="WeightTypeName" valueKey="WeightTypeId" label="Weight Terms">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="SASTermID" [required]="true" [(ngModel)]="Inventory.SASTermID"
                  [options]="InventoryData.SampleApprovalTerms" labelKey="SampleApprovalTerm" valueKey="SampleApprovalTermID" label="SAS Terms">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="FutureCompositeID" [required]="true"
                  [(ngModel)]="Inventory.FutureCompositeID"
                  (ngModelChange)="recalculateCostsDebounced()"
                  [options]="InventoryData.FuturesMonths" labelKey="FutureCompositeName" valueKey="FutureCompositeID" label="Futures Month">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-radio [required]="true" name="fixedby" [(ngModel)]="Inventory.PriceFixedBy" style="width:96%"
                  [options]="[{value: 1, label: 'Royal NY'}, {value: 2, label: 'Supplier'}]"
                  label="Price To Be Fixed By" (ngModelChange)="SetPriceToBeFixedBy(Inventory)">
      </rms-radio>
    </div>

    <div class="form-field">
      <rms-select name="BuyingTermID" [required]="true" [(ngModel)]="Inventory.BuyingTermID"
                  [options]="[{value: 1, label:'Fixed'}, {value:2, label: 'Differential'}]"
                  labelKey="label" valueKey="value" label="Fixed Or Differential"
                  (ngModelChange)="onUpdateBuyingTermID()">
      </rms-select>
    </div>

    <div class="form-field">
      <rms-select name="PriceDescriptorID" [required]="true"
                  [(ngModel)]="Inventory.PriceDescriptorID"
                  [options]="filteredPricings" labelKey="PriceDescriptorName" valueKey="PriceDescriptorID" label="Price Descriptor"
                  (ngModelChange)="onPriceDescriptorChange()">
      </rms-select>
    </div>

    @if(Inventory.BuyingTermID === 2){
    <div class="form-field" [ngClass]="{'fade-in': Inventory.BuyingTermID, 'fade-out': !Inventory.BuyingTermID}">
      <rms-input name="diff" [suffix]="PerPoundCost + '/lb'" type="currency"
                  [required]="true"
                  (ngModelChange)="onDiffChange($event)"
                  [(ngModel)]="Diff" label="Differential ({{getUnitsForPurchasePrice()}})">
      </rms-input>
    </div>
    }
    @else{
    <div class="form-field" [ngClass]="{'fade-in': Inventory.BuyingTermID, 'fade-out': !Inventory.BuyingTermID}">
      <rms-input type="currency" [suffix]="PerPoundCost + '/lb'" name="price"
                  [required]="true"
                  (ngModelChange)="onPriceChange($event)"
                  [(ngModel)]="Price" label="Price ({{getUnitsForPurchasePrice()}})">
      </rms-input>
    </div>
    }

    <div class="form-field">
      <rms-textarea name="notes" [(ngModel)]="Inventory.Notes" label="Inventory Notes"
                    (ngModelChange)="recalculateCostsDebounced()"></rms-textarea>
    </div>

    <div class="form-field">
      <rms-input [noMargin]="true" name="Intermediary" label="Intermediary" [(ngModel)]="Inventory.Intermediary"
                  (ngModelChange)="recalculateCostsDebounced()"></rms-input>
    </div>

    <div class="form-field">
      <rms-input [noMargin]="true" name="IntermediaryNumber" label="Intermediary Number" [(ngModel)]="Inventory.IntermediaryNumber"
                  (ngModelChange)="recalculateCostsDebounced()"></rms-input>
    </div>

    <fieldset class="rms-fieldset form-field" style="gap:0">
      <legend style="font-size:18px">Commissions</legend>
      <rms-input name="SupplierCommission" type="currency" style="width:96%" [noMargin]="true"
                  (ngModelChange)="recalculateCostsDebounced()" [(ngModel)]="Inventory.SupplierCommission" label="Supplier" decimalFormat="1.4-4">
      </rms-input>
      <rms-input name="RainforestCommission" type="currency" style="width:96%" class="form-field" [noMargin]="true"
                  (ngModelChange)="recalculateCostsDebounced()" [(ngModel)]="Inventory.RainforestCommission" label="Rainforest" decimalFormat="1.4-4">
      </rms-input>
      <rms-input name="OrganicCommission" type="currency" style="width:96%" class="form-field" [noMargin]="true"
                  (ngModelChange)="recalculateCostsDebounced()" [(ngModel)]="Inventory.OrganicCommission" label="Organic" decimalFormat="1.4-4">
      </rms-input>
      <rms-input name="IntermediaryCommission" type="currency" style="width:96%" class="form-field" [noMargin]="true"
                  (ngModelChange)="recalculateCostsDebounced()" [(ngModel)]="Inventory.IntermediaryCommission" label="Intermediary" decimalFormat="1.4-4">
      </rms-input>
      <rms-input name="CommissionOtherLevel" type="currency" style="width:96%" class="form-field" [noMargin]="true"
                  (ngModelChange)="recalculateCostsDebounced()" [(ngModel)]="Inventory.CommissionOtherLevel" label="Miscellaneous" decimalFormat="1.4-4">
      </rms-input>
    </fieldset>

    @if(Inventory.FairTrade){
    <fieldset class="rms-fieldset form-field" style="gap:0">
      <legend style="font-size:18px">Fair Trade</legend>
      <rms-input name="FairTradeMinimum" type="currency" style="width:96%" [noMargin]="true"
                  [(ngModel)]="Inventory.FairTradeMinimum" label="Fair Trade Minimum" decimalFormat="1.4-4"
                  (ngModelChange)="recalculateCostsDebounced()">
      </rms-input>
      <rms-input name="FairTradePremium" type="currency" style="width:96%" [noMargin]="true"
                  [(ngModel)]="Inventory.FairTradePremium" label="Fair Trade Premium" decimalFormat="1.4-4"
                  (ngModelChange)="recalculateCostsDebounced()">
      </rms-input>
      <rms-input name="org" type="currency" style="width:96%" [noMargin]="true"
                  [(ngModel)]="Inventory.OrganicPremium" label="Organic Premium" decimalFormat="1.4-4"
                  (ngModelChange)="recalculateCostsDebounced()">
      </rms-input>
      <rms-input name="cprem" type="currency" style="width:96%" [noMargin]="true"
                  [(ngModel)]="Inventory.CountryPremium" label="Country Premium" decimalFormat="1.4-4"
                  (ngModelChange)="recalculateCostsDebounced()">
      </rms-input>
    </fieldset>
    }

    <div class="flex-break"></div>



    <fieldset class="form-field rms-fieldset" style="gap: 0; width:16%" [ngClass]="{'fade-in' : Inventory.BuyingTermID == 1, 'fade-out': Inventory.BuyingTermID != 1}">
      <legend>Risk Management</legend>
      <div class="form-field">
        <rms-radio [disabled]="Inventory.BuyingTermID == 2" name="hedged" [(ngModel)]="Inventory.IsHedged" style="width:96%"
                    [options]="[{value: 1, label: 'Yes'}, {value: 2, label: 'No'}]"
                    label="Internally Hedged" [required]="Inventory.BuyingTermID == 1" (ngModelChange)="SetHedged()">
        </rms-radio>
      </div>
      <div class="form-field" style="width:96%" [ngClass]="{'fade-in' : Inventory.IsHedged == 1, 'fade-out': Inventory.IsHedged == 2 || !Inventory.IsHedged}">
        <rms-search-select name="riskticket" [disabled]="true" [options]="InventoryData.OpenRiskTickets" valueKey="TicketNumber" labelKey="Label"
                            [(ngModel)]="Inventory.RiskTicketID" label="Risk Ticket"></rms-search-select>
      </div>

      @if(Inventory.BuyingTermID != 2){
      <div class="form-field" style="width:96%" [ngClass]="{'fade-in' : Inventory.RiskTicketID, 'fade-out': !Inventory.RiskTicketID}">
        <rms-input name="FixationBasis" type="currency" [(ngModel)]="Inventory.FixationBasis" label="Fixation"
                    (ngModelChange)="updatePerPoundCost(); recalculateCostsDebounced()"></rms-input>
      </div>
      <div class="form-field" [ngClass]="{'fade-in' : Inventory.RiskTicketID, 'fade-out': !Inventory.RiskTicketID}">
        <rms-date name="datefixed" style="width:96%" [(ngModel)]="Inventory.DateFixed" label="Date Fixed"
                  (ngModelChange)="recalculateCostsDebounced()"></rms-date>
      </div>
      }
    </fieldset>

    <div class="flex-break"></div>

    <!--@if(Inventory.Decaf || (inventoryForm.valid && (Inventory.Destination == 15 || Inventory.Destination == 10))){
    <rms-checkbox name="decaf" label="Decaffeinate" [(ngModel)]="Inventory.Decaf" (ngModelChange)="recalculateCostsDebounced()"></rms-checkbox>
    }-->
    @if(Inventory.Decaf){
    <fieldset class="rms-fieldset form-field growOnShow" style="gap: 0; width:23%">
      <legend>Decaf</legend>
      <rms-search-select name="decafid" style="width:96%" [options]="InventoryData.DecafProducts" label="Decaf Product"
                          [(ngModel)]="Inventory.DecafID" (ngModelChange)="setDecafDefaults()"
                          labelKey="InventoryTypeName" valueKey="InventoryTypeID" [required]="Inventory.Decaf">
      </rms-search-select>

      <div style="width:96%" [ngClass]="{'fade-in': Inventory.Child, 'fade-out': !Inventory.Child}">
        @if(Inventory.Child){
        <rms-select name="decafin" [options]="InventoryData.Decaffeinators" (ngModelChange)="recalculateDecafCostsDebounced()"
                    label="Decaffeinator" [(ngModel)]="Inventory.Child.DecaffeinatorID" labelKey="DecaffeinatorName" valueKey="DecaffeinatorID" [required]="Inventory.Decaf">
        </rms-select>

        <rms-select name="decafwarehouse" [options]="InventoryData.DestinationWarehouses" (ngModelChange)="recalculateDecafCostsDebounced()"
                    label="Receiving Warehouse" [(ngModel)]="Inventory.Child.FinalDestinationWarehouseID" labelKey="LocationName" valueKey="LocationID" [required]="Inventory.Decaf">
        </rms-select>

        <div style="display:flex; justify-content:space-around;">
          <rms-number name="bagstodecaf" [required]="true" [(ngModel)]="Inventory.BagsOrdered"
                      (ngModelChange)="updateDecafBags(); recalculateDecafCostsDebounced()" label="Bags To Decaffeinate"></rms-number>
          <rms-number name="decafbags" [(ngModel)]="Inventory.Child.BagsOrdered" [disabled]="true" label="Final Bag Count"></rms-number>
        </div>

        <div style="display:flex; justify-content:space-around">
          <rms-select name="decafetdm" [required]="true" [(ngModel)]="Inventory.Child.ETDMonth" [options]="InventoryData.Months" labelKey="label" valueKey="value" label="ETD Month"
                      (ngModelChange)="recalculateDecafCostsDebounced()"></rms-select>
          <rms-select name="decafetdy" [required]="true" [(ngModel)]="Inventory.Child.ETDYear" [options]="InventoryData.Years" labelKey="label" valueKey="value" label="ETD Year"
                      (ngModelChange)="recalculateDecafCostsDebounced()"></rms-select>
        </div>

        <rms-input name="decafpos" [disabled]="true" [(ngModel)]="Inventory.Child.FinalPosition" label="Position"></rms-input>
        }
        <div style="display:flex; justify-content:space-around">
          <div class="form-field" style="display:flex; flex-direction:row; gap:30px; align-items:center">
            <rms-input name="decaftoll" type="currency" [required]="true" [(ngModel)]="tollingCost" label="Tolling Cost"
                        (ngModelChange)="onChangeTollingCost($event)" decimalFormat="1.4-4"></rms-input>
            <button class="btn-bg-blue" type="button" mat-icon-button title="Click To View Calc" (click)="toggleDecafTotals()"><mat-icon>info</mat-icon></button>
          </div>
          @if(Inventory.Child){
          @if(Inventory.Child.DecaffeinatorID == 1992){
          <rms-select name="decafcontractsdm" label="Tolling Contract" [options]="InventoryData.TollingContracts" labelKey="Label" valueKey="TollingContractID" [(ngModel)]="Inventory.Child.DecafTollingContractID"></rms-select>
          }
          @else{
          <rms-input name="decafContracts" type="text" label="Tolling Contract" [(ngModel)]="Inventory.Child.DecafTollingContractID"></rms-input>
          }
          }
        </div>
      </div>
    </fieldset>
    }
  </div>

  @if(Inventory.InventoryTypeID){
  <div class="form-actions">
    <button type="button" mat-surface-button class="btn-bg-red" (click)="LeaveInventoryForm()">Cancel</button>
    <span class="validation-note" *ngIf="inventoryForm.invalid">Complete: {{invalidFieldLabels(inventoryForm)}}.</span>
    <span class="validation-note" *ngIf="calculationError">{{calculationError}}</span>
    <button type="button" mat-flat-button [disabled]="saving || !inventoryForm.valid || !Inventory.InventoryTypeID || Inventory.FixationCurrentLevel == null || !!calculationError" class="btn-bg-green" (click)="SaveInventoryForm()">
      {{saving ? 'Saving…' : Inventory.InventoryID ? 'Save inventory changes' : 'Add to purchase order'}}
    </button>
  </div>
  }

  <app-calc-form *ngIf="showTotals || showDecafTotals"
                  [calcData]="calcModalData"
                  (onDataChange)="handleTotalsChange($event)"
                  (close)="onCalcClose()">
  </app-calc-form>

</form>
